/**
 * A deliberate cancel is stored as queue_state='canceled' but reads as
 * processing_status='failed' (migration-042 trigger). Surfaces that offer
 * Reprocess must say "cancelled" so an operator does not re-queue work that
 * was removed on purpose (CUR-2048).
 */
export interface QueueRowLike {
  queue_state?: string | null;
  cancel_reason?: string | null;
}

export interface CancelledLabel {
  label: 'Cancelled';
  title: string;
}

export function cancelledLabel(row: QueueRowLike): CancelledLabel | null {
  if (row.queue_state !== 'canceled') return null;
  return { label: 'Cancelled', title: row.cancel_reason || 'Cancelled' };
}
